import React, { useState } from 'react'
import { Badge, Col, Container, Row } from 'react-bootstrap';

import {
    LinkedinShareButton,
    EmailShareButton,
    TwitterShareButton,
} from "react-share";

import {CopyToClipboard} from 'react-copy-to-clipboard';
import Expire from './Expire';

const ShareButtons = ({title, url,summary, body}) => {

    const [copied, setCopied] = useState(false);
    // console.log(copied);

    return(
    <div className="networks">  
        <Container>  
            <div className="our-networks">
                <p>Share with your network</p> 
            </div>
        <Row style={{textAlign:"center"}}>
            <Col md="1" lg="2"></Col>
            <Col>
                <EmailShareButton  className="share-network"  subject={title} body={body} separator=" ">
                    <img src={require('../assets/images/networks/email.svg')}  alt="Logo" />
                    <span className="title">Email</span>
                </EmailShareButton>
            </Col>
            <Col>
                <TwitterShareButton className="share-network" url={url} title={title}>
                    <img src={require('../assets/images/networks/twitter.svg')}  alt="Logo" />
                    <span className="title">Tweet</span>
                </TwitterShareButton>
            </Col>
            <Col>
                <LinkedinShareButton className="share-network" url={url} title={title} summary={summary} >
                    <img src={require('../assets/images/networks/linkedin.svg')}  alt="Logo" />
                    <span className="title">Share</span>
            </LinkedinShareButton>
            </Col>
            <Col>
                <CopyToClipboard className="share-network" text={url} onCopy={()=>setCopied(!copied)}>
                    <div> 
                        <img className="share-link-img" src={require('../assets/images/networks/share.svg')}  alt="Logo" />
                        <span className="title">Share link</span>
                        {copied === true  ?  <Expire delay={1000}> <Badge variant="success" className="badge-url">Link copied</Badge ></Expire> : null}
                    </div>
                </CopyToClipboard>
            
            </Col>
            
            <Col md="1" lg="2"></Col>
        </Row>
        </Container>
    </div>
    )

}
export default ShareButtons